<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";
import { createImageBlock } from "~/stores/mail-block-editor/defaults";
import {
    MailMjmlColumn,
    MailMjmlSection,
} from "#components";

const store = useMailStore();
const builder = useMailStore();
const props = defineProps(nodeViewProps);
const theme = computed(() => {
    const theme = createImageBlock(props.node.attrs ?? {});
    const topLeft =
        props.node.attrs.borderTopLeftRadius ?? theme?.borderTopLeftRadius;
    const bottomLeft =
        props.node.attrs.borderBottomLeftRadius ??
        theme?.borderBottomLeftRadius;
    const topRight =
        props.node.attrs.borderTopRightRadius ?? theme?.borderTopRightRadius;

    const bottomRight =
        props.node.attrs.borderBottomRightRadius ??
        theme?.borderBottomRightRadius;

    return builder.fieldCollection.replaceContent({
        paddingBottom: theme.marginBottom,
        paddingTop: theme.marginTop,
        src: theme.src,
        alignment: theme.alignment,
        caption: theme.caption,
        height: theme.height,
        borderRadius: `${topLeft} ${topRight} ${bottomRight} ${bottomLeft}`,
    });
});

const block = computed({
    get: () => useCloneDeep(store.getBlockById(props.node.attrs.id).block?.attrs ?? {}),
    set: (value) => props.updateAttributes(value),
});
</script>

<template>
    <NodeViewWrapper class="image" @click.stop="store.focusedJsonId = node.attrs.id">
        <MailMjmlSection :css-class="node.attrs.identifier" :contenteditable="false" :full-width="node.attrs.fullWidth">
            <MailMjmlColumn width="100%">
                <MailMjmlImage :padding-top="theme.paddingTop" :padding-bottom="theme.paddingBotom" :src="theme.src"
                    :alt="theme.caption" :height="theme.height" :align="theme.alignment"
                    :border-radius="theme.borderRadius" :width="node.attrs.fullWidth ? '100%' : 'auto'">
                    <MailBlockSettingBaseImage :fields="builder.builderFields"
                        button-class="justify-center items-center flex-col" :style="{ height: theme.height }"
                        v-if="!block.src" :model-value="block.src"
                        @update:model-value="block = { ...block, src: $event }" />
                </MailMjmlImage>
            </MailMjmlColumn>
        </MailMjmlSection>
    </NodeViewWrapper>
</template>
